/**
 * Urgences — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: URG
 * Catalogue acts (NGAP Maroc): 90
 */
import { defineSpecialty } from "../types";

export const urgences = defineSpecialty(
{
  "id": "urgences",
  "label": "Urgences",
  "short": "Urgences",
  "scope": "Actes d'urgence et réanimation",
  "aliases": [
    "URG"
  ],
  "doctorSpecs": [
    "Médecine d'urgence",
    "Réanimation"
  ],
  "featureFlag": "ux.v2.urgences",
  "theme": {
    "primary": "oklch(0.66 0.21 25)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.80 0.15 70)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "triage",
      "label": "Triage",
      "icon": "ListChecks",
      "route": "/clinical/triage",
      "order": 1,
      "requires": []
    },
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 2,
      "requires": []
    },
    {
      "id": "monitoring",
      "label": "Surveillance",
      "icon": "Activity",
      "route": "/clinical/monitoring",
      "order": 3,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 4,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 5,
      "requires": [
        "imaging"
      ]
    }
  ],
  "panels": [
    {
      "id": "triage",
      "label": "Triage",
      "icon": "ListChecks",
      "component": "TriageBoard",
      "order": 1,
      "requires": []
    },
    {
      "id": "vitals",
      "label": "Constantes",
      "icon": "Gauge",
      "component": "VitalSignsGrid",
      "order": 2,
      "requires": []
    },
    {
      "id": "monitoring",
      "label": "Monitor",
      "icon": "Activity",
      "component": "ContinuousMonitor",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Urgences",
    "subSpecialties": [
      "Consultation",
      "Réanimation",
      "Acte d'urgence",
      "Transfert"
    ],
    "catalogueActs": 90
  },
  "terminology": {
    "icd10": [
      "R00",
      "R50",
      "R57",
      "T78",
      "S00"
    ],
    "loinc": [
      "34565-2",
      "9279-1"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "defibrillator",
    "monitor-multiparametric",
    "ventilator-icu"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default urgences;
